import { useEffect, useState } from 'react';
import { Image } from '@chakra-ui/react';

interface ICardIconProps {
  icon: string;
  iconType: 'flat' | 'mono' | 'outline' | 'single';
}

export const CardIcon = (props: any) => {
  const { icon, iconType = 'flat' }: ICardIconProps = props;

  const [image, setImage] = useState(undefined);

  useEffect(() => {
    (async () => {
      const { default: svg } = await import(
        `payment-icons/min/${iconType}/${icon}.svg`
      );
      setImage(svg);
    })();
  }, [icon, iconType]);

  return (
    <>{image && <Image opacity="1" src={image} data-testid="card-icon" />}</>
  );
};
